import { t } from 'i18next';
import { object, string, array, bool, boolean, lazy, number } from 'yup';

import i18n from '../../../i18n';
import { sentenceCase } from '../../../utils/utils';

const inputReq = (field, nameSpace) =>
  sentenceCase(
    i18n.t('inputRequired', {
      ns: 'validations',
      field: i18n.t(field, { ns: nameSpace }),
    })
  );

const selectReq = (field, nameSpace) =>
  sentenceCase(
    i18n.t('selectRequired', {
      ns: 'validations',
      field: i18n.t(field, { ns: nameSpace }),
    })
  );

export const schema = () =>
  object({
    settings: object({
      query: object({
        requestHandler: string().when('jsonQuery.params.dense', {
          is: true,
          then: (schema) => schema,
          otherwise: (schema) =>
            schema.required(inputReq('search.requestHandler', 'fields')),
        }),
        collection: string().required(selectReq('search.collection', 'fields')),
        uniqueKey: string().required(
          i18n.t('noUniqueKey', { ns: 'validations' })
        ),
        display: object({
          title: string(),
          body: string(),
          image: string(),
          url: string(),
        }),
        rawQueryParams: string(),
        jsonQuery: object({
          query: string().nullable(),
          sort: string(),
          fields: array(),
          params: object({
            dense: bool(),
            denseField: string().when('dense', {
              is: true,
              then: (schema) =>
                schema.required(inputReq('search.denseField', 'fields')),
              otherwise: (schema) => schema,
            }),
            denseTopK: lazy((val) =>
              val === ''
                ? string()
                : number()
                    .typeError(t('numRequired', { ns: 'validations' }))
                    .positive(t('positiveRequired', { ns: 'validations' }))
                    .integer(t('wholeNumRequired', { ns: 'validations' }))
            ),
            hl: boolean(),
            fl: string(),
            requireFieldMatch: boolean(),
            usePhraseHighLighter: boolean(),
            highlightMultiTerm: boolean(),
            facet: boolean(),
            facetField: string(),
            facetQuery: string(),
            df: string(),
            defType: string().required(
              selectReq('search.queryParser', 'fields')
            ),
            debugQuery: boolean(),
            op: string().required(selectReq('search.queryOperator', 'fields')),
            alt: string(),
            qf: string(),
            mm: string(),
            pf: string(),
            ps: string(),
            qs: string(),
            tie: string(),
            bq: string(),
            bf: string(),
            uf: string(),
            pf2: string(),
            pf3: string(),
            ps2: string(),
            ps3: string(),
            boost: string(),
            stopwords: boolean(),
            lowercaseOperators: boolean(),
          }),
        }),
      }),
      suggest: object({
        collection: string(),
        requestHandler: string(),
        dictionary: string(),
      }),
    }),
  });

export const saveQuerySchema = () =>
  object({
    queryName: string()
      .required(inputReq('search.queryName', 'fields'))
      .max(50, i18n.t('maxLength', { ns: 'validations', max: '50' })),
  });

export const defaultValues = {
  settings: {
    query: {
      requestHandler: '/select',
      collection: '',
      uniqueKey: '',
      display: {
        title: '',
        body: '',
        image: '',
        url: '',
      },
      rawQueryParams: '',
      jsonQuery: {
        query: '',
        sort: '',
        params: {
          dense: false,
          hl: false,
          facet: false,
          defType: 'lucene',
          debugQuery: false,
          op: 'OR',
          df: '',
          stopwords: false,
          lowercaseOperators: false,
        },
      },
    },
    suggest: {
      collection: '',
      requestHandler: '',
      dictionary: '',
    },
  },
};
